<template>
  <!--保全存证-->
  <div class="deal-type">
    <el-row type="flex" class="row">
      <el-col :span="7"> </el-col>
      <el-col :span="4">
        <el-select v-model="selectType" size="small" style="width: 150px">
          <el-option value="contractName" label="文件名称" />
          <el-option value="applyNo" label="文件编号" />
          <el-option value="signatoryFullName" label="签署方" />
          <el-option value="signatoryMobile" label="手机号" />
          <el-option value="signatoryIdentityCard" label="证件号" />
        </el-select>
      </el-col>
      <el-col :span="4" :key="selectType">
        <el-input
          v-model="applySeachParam[selectType]"
          placeholder="查询内容"
          size="small"
          style="width: 150px"
        />
      </el-col>
      <el-col :span="6">
        <el-date-picker
          v-model="datePikerArr"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 254px"
        />
      </el-col>
      <el-col :span="3" class="text-right">
        <el-row type="flex">
          <el-col :span="12">
            <el-button @click="getDataList" size="small">查询</el-button>
          </el-col>
          <el-col :span="12">
            <el-button @click="rest" size="small">重置</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-table
      :data="dataList"
      v-loading="loading"
      class="data-list"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      :header-cell-style="{
        background: '#f9f9f9',
        color: '#333333',
        fontWeight: '500',
      }"
    >
<!--      <el-table-column type="selection" width="55" />-->
      <el-table-column label="文件编号" prop="applyNo" show-overflow-tooltip />
      <el-table-column
        label="文件名称"
        prop="contractName"
        show-overflow-tooltip
      />
      <el-table-column
        label="签署方"
        prop="allSignerName"
        show-overflow-tooltip
      />
      <el-table-column label="发起时间" show-overflow-tooltip>
        <template slot-scope="scope">{{
          scope.row.createTime | formatDate
        }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <div
          slot-scope="scope"
          v-if="!scope.row.childSend"
          class="action pointer"
        >
          <span
            @click="lookDetailFn(scope.row)"
            class="color-success span options-sty"
            >查看
          </span>
          <template
            v-if="scope.row.signStatus === 0 && scope.row.createType === 1"
          >
            <span class="color-success span options-sty">撤销</span>
          </template>
          <template
            v-if="
              (scope.row.signStatus === 0 ||
                scope.row.signStatus === 1 ||
                scope.row.signStatus === 2) &&
              scope.row.createType === 0
            "
          >
            <span @click="gotoTestify(scope.row)" class="color-success span options-sty"
              >证书</span
            >
          </template>
        </div>
      </el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>

    <el-row class="pageation row">
      <el-col :span="4">
        <!--<el-button @click="cancelApply" size="small">删除</el-button>-->
        <div style="height: 20px"><!--占位--></div>
      </el-col>
      <el-col :span="20" class="page-flex-end">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="applySeachParam.itemPage"
          :pager-count="5"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="applySeachParam.pageSize"
          layout="sizes, prev, pager, next, total"
          :total="applySeachParam.total"
        />
        <el-go
          :page-size="applySeachParam.pageSize"
          :total="applySeachParam.total"
          @current-change="handleCurrentChange"
        ></el-go>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="showChooseCert"
      title="请选择主体身份"
      width="500px"
      :close-on-click-modal="false"
    >
      <div v-if="certList && certList.length > 0">
        <template v-for="(item, index) in certList">
          <div :key="index">
            <el-radio v-model="choosedCert" :label="index">{{
              item.idenName
              }}</el-radio>
          </div>
        </template>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button
          @click="certificateJumpFn(certList[choosedCert])"
          size="small"
          type="danger"
        >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { isInDingTalk } from '@/assets/js/utils/ding-env';
import {
  postApplyPage,
  cancelApplyByApplyNO,
  ApiMethods
} from "../../assets/js/http-serve/http-methods";
import ElGo from "../../components/go/Go";
export default {
  components: { ElGo },
  data () {
    return {
      certList: [], //签署方弹窗
      showChooseCert: false,
      choosedCert: 0,

      dataList: [],
      // 列表查询参数
      applySeachParam: {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: "",
        endDate: "",
        applyNo: "",
        contractName: "",
        signatoryFullName: "",
        signatoryMobile: "",
        signatoryIdentityCard: "",
        signStatus: null,
        createType: 0,
        dealType: 2
      },
      selectType: "contractName",
      datePikerArr: [],
      // 删除合同的applyIds
      applyIds: "",
      loading: false
    };
  },
  watch: {
    selectType (val, oldVal) {
      this.applySeachParam[oldVal] = "";
    },
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.applySeachParam.beginDate = val[0];
          this.applySeachParam.endDate = val[1];
        } else {
          this.applySeachParam.beginDate = this.applySeachParam.endDate = null;
        }
      },
      deep: true
    }
  },
  mounted () {
    this.getDataList();
  },
  methods: {
    //查看
    lookDetailFn(item) {
      if (item.dealType === 6) {
        this.$message.error('当前为hash保全，无可预览文件');
      } else {
        const url = this.$router.resolve({path: '/applySign/toDetailAnony', query: { applyNo: item.applyNo }});
        window.open(url.href, '_blank');
      }
    },
    // 重置
    rest () {
      this.applySeachParam = {
        itemPage: 1,
        pageSize: 10,
        total: 0,
        dateType: null,
        beginDate: "",
        endDate: "",
        applyNo: "",
        contractName: "",
        signatoryFullName: "",
        signatoryMobile: "",
        signatoryIdentityCard: "",
        signStatus: null,
        createType: 0,
        dealType: 2
      };
      this.datePikerArr = [];
      this.selectType = "contractName";
      this.getDataList();
    },
    // 获取列表信息
    getDataList () {
      this.loading = true;
      postApplyPage(this.applySeachParam)
        .then(data => {
          if (data.data) {
            this.dataList = data.data;
            this.applySeachParam.itemPage = data.pageNum;
            this.applySeachParam.pageSize = data.pageSize;
            this.applySeachParam.total = data.total;
          }
        })
        .catch(err => {
          console.log("保全存证列表：" + JSON.stringify(err));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSizeChange (val) {
      this.applySeachParam.itemPage = 1;
      this.applySeachParam.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange (val) {
      this.applySeachParam.itemPage = val;
      this.getDataList();
    },
    cancelApply () {
      if (!this.applyIds)
        return this.$confirm("请选择要删除的数据", "系统提示", {
          showCancelButton: false,
          showConfirmButton: true,
          type: "info"
        });

      this.$confirm("删除后将不能恢复，确认删除？", "系统提示", {
        showConfirmButton: true,
        showCancelButton: true,
        type: "info"
      }).then(() => {
        cancelApplyByApplyNO(this.applyIds)
          .then(data => {
            this.$confirm("合同删除成功", "系统提示", {
              type: "success",
              confirmButtonText: "确定",
              showCancelButton: false
            });
            this.getDataList();
          })
          .catch(err => {
            this.$confirm("合同删除失败, 请刷新后再试", "系统提示", {
              type: "warning",
              confirmButtonText: "确定",
              showCancelButton: false
            });
            console.error("撤销合同：" + JSON.stringify(err));
          });
      });
    },
    // table 选择列表
    handleSelectionChange: function (val) {
      let arr = [];
      if (val) {
        val.forEach(t => {
          arr.push(t.applyId);
        });
      }
      this.applyIds = arr.join(",");
    },
    //证书跳转
    certificateJumpFn(data) {
      let newWindow = '';
      if (!isInDingTalk) newWindow = window.open("about:blank");
      ApiMethods.CertiController.redirectTesity({
        ...data,
        newUrl: 1,
      }).then(res => {
        if (res.success) {
          if (isInDingTalk) location.href = res.data;
          if (!isInDingTalk) newWindow.location.href = res.data;
        } else {
          this.$message.error(res.description || this.$tip);
          if (!isInDingTalk) newWindow.close();
        }
      });
    },
    // 证书
    gotoTestify: function (item) {
      let _this = this;
      let param = {
        signNo: item.signInfoNo || "",
        applyNo: item.applyNo || ""
      };
      ApiMethods.UserApplySignController.viewUrl(param).then(viewResult => {
        //{"applyNo":"","ts":,"sign":"","signNo":""}
        if (!viewResult.success) {
          return _this.$message.error(
            viewResult.description || "初始化数据失败1"
          );
        }
        ApiMethods.ApplySignController.certi(viewResult.data).then(
          redirectResult => {
            if (redirectResult.success) {
              // _this.$router.push({
              //   path: "/certi/certiPage",
              //   query: redirectResult.data
              // });
              if (redirectResult.data.length == 1) {
                this.certificateJumpFn(redirectResult.data[0]);
              } else {
                this.certList = redirectResult.data;
                this.showChooseCert = true;
              }
            } else {
              _this.$message.error(redirectResult.description);
            }
          }
        );
      });
    }
  },
  name: "viewDealTypeList"
};
</script>

<style lang="less" scoped>
.options-sty{
  color:#290202;
}
.action .span {
  margin-right: 5px;
  display: inline-block;
  cursor: pointer;
}
.deal-type {
  max-width: 1200px;
  margin: 10px auto 0 auto;
  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
  }
  .dialog-footer {
    padding-bottom: 20px;
    .btn {
      width: 30%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/signInfo/viewDealTypeList.vue